import { createContext, useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../services/auth.service";
import { setLogoutHandler } from "../services/api";

const AuthContext = createContext();

function AuthProviderWrapper(props) {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Derivar roles del usuario en lugar de múltiples useState
  const isAdmin = user?.rol === "ADMIN";
  const isTreasurer = user?.rol === "TESORERA";
  const isStock = user?.rol === "UNIFORMIDAD";

  const logout = useCallback(() => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("refreshToken");
    setUser(null);
    setIsLoading(false);
    navigate("/", { replace: true });
  }, [navigate]);

  const authenticateUser = useCallback(() => {
    const token = localStorage.getItem("authToken");
    const refreshToken = localStorage.getItem("refreshToken");

    if (token) {
      setIsLoading(true);
      authService
        .verify(token)
        .then(({ data }) => {
          setUser(data);
        })
        .catch(() => logout())
        .finally(() => setIsLoading(false));
    } else if (refreshToken) {
      setIsLoading(true);
      authService
        .refresh(refreshToken)
        .then(({ data }) => {
          if (data?.authToken) {
            localStorage.setItem("authToken", data.authToken);
          }
          if (data?.refreshToken) {
            localStorage.setItem("refreshToken", data.refreshToken);
          }
          return authService.verify(
            data?.authToken || localStorage.getItem("authToken")
          );
        })
        .then(({ data }) => {
          setUser(data);
        })
        .catch(() => logout())
        .finally(() => setIsLoading(false));
    } else {
      localStorage.removeItem("refreshToken");
      sessionStorage.removeItem("authToken");
      sessionStorage.removeItem("refreshToken");
      setUser(null);
      setIsLoading(false);
    }
  }, [logout]);

  // Registrar logout handler para llamadas 401 automáticas
  useEffect(() => {
    setLogoutHandler(logout);
    return () => setLogoutHandler(null);
  }, [logout]);

  useEffect(() => {
    authenticateUser();
  }, [authenticateUser]);

  return (
    <AuthContext.Provider
      value={{
        authenticateUser,
        user,
        logout,
        isLoading,
        isAdmin,
        isTreasurer,
        isStock,
        setIsLoading,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProviderWrapper };
